import { useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentApi } from '../services/paymentApi';
import { useHybridAuth } from './useHybridAuth';

export function useMarkInvoiceAsPaid(
  dispatchId: string,
  companyId: string | undefined
) {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useHybridAuth();

  return useMutation({
    mutationFn: async (invoiceId: string) => {
      if (!companyId) {
        throw new Error('Company ID is required');
      }
      const token = await getAccessTokenSilently();
      return paymentApi.markAsPaid(invoiceId, companyId, token);
    },
    onSuccess: () => {
      // Invalidate payment status cache
      queryClient.invalidateQueries({
        queryKey: ['payment-status', dispatchId, companyId],
      });
      paymentApi.clearCache(dispatchId);
    },
  });
}
